var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 799 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10.984,
    y: 53.145,
    width: 26.697,
    height: 26.697,
    transform: "translate(-40.084 37.1) rotate(-45.373)",
    style: {
      fill: "#9a9bab",
      stroke: "#9a9bab",
      strokeMiterlimit: 8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.634 127.333 10.315 113.014 56.875 66.454 10.315 19.894 24.634 5.575 85.513 66.454 24.634 127.333",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.953 127.963 52.488 113.498 99.521 66.465 52.488 19.431 66.953 4.967 128.45 66.465 66.953 127.963",
    style: {
      fill: "#9a9bab",
      stroke: "#9a9bab",
      strokeMiterlimit: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.784,15.527h35.768q14.675,0,22.016,6.375t7.339,20.024q0,9.753-3.206,15.226a22.174,22.174,0,0,1-9.476,8.625q15.674,5.7,15.674,24.45,0,15.6-7.837,22.349t-22.658,6.75h-37.62Zm35.341,10.2H154.757v35.85h25.365q9.117,0,13.324-4.576t4.2-13.8q0-9.226-4.488-13.35T179.125,25.727Zm1.139,45.9H154.757v37.5h26.22q9.689,0,14.749-4.274t5.058-15.076a20.335,20.335,0,0,0-2.066-9.6,12.282,12.282,0,0,0-5.486-5.55A29.736,29.736,0,0,0,180.264,71.626Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.286,119.326v-75h10.546v10.2a67.678,67.678,0,0,1,26.077-11.851v11.4a73.907,73.907,0,0,0-12.469,3.75,80.746,80.746,0,0,0-9.9,4.5l-3.562,1.95v55.049Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.191,110.026l4.133-.45.285,8.85a194.836,194.836,0,0,1-27.788,2.4q-15.389,0-21.8-9.375t-6.413-29.175q0-39.448,29.783-39.449,14.391,0,21.517,8.474t7.125,26.625l-.57,8.551H282.437q0,12.45,4.274,18.449t14.892,6Q312.217,110.926,323.191,110.026Zm-3.847-32.549q0-13.8-4.2-19.5t-13.68-5.7q-9.478,0-14.25,6t-4.916,19.2Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.58,66.977v38.4q.428,5.551,8.265,6.6l-.428,8.849q-11.259,0-16.957-6a60.068,60.068,0,0,1-25.65,6q-9.833,0-14.963-5.849t-5.13-16.8q0-10.947,5.273-16.125t16.53-6.375l22.373-2.25V66.977q0-7.652-3.135-10.95a11.244,11.244,0,0,0-8.551-3.3,194.962,194.962,0,0,0-23.655,1.5l-4.417.449-.428-8.55a136.854,136.854,0,0,1,27.788-3.3q12.109,0,17.6,5.849T395.58,66.977Zm-43.891,30.6q0,13.8,10.831,13.8a55.021,55.021,0,0,0,19.1-3.45l3.278-1.2V81.977l-21.09,2.1q-6.414.6-9.263,3.9T351.689,97.576Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.892,42.827a117.149,117.149,0,0,1,15.96,1.8l3.419.451-.427,9.15a159.067,159.067,0,0,0-16.815-1.351q-12.114,0-16.459,6.076t-4.345,22.5q0,16.425,4.06,22.875t16.887,6.45l16.814-1.35.428,9.3a139.693,139.693,0,0,1-19.808,2.1q-16.673,0-23.013-9t-6.341-30.375q0-21.375,6.84-30T441.892,42.827Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.635,119.326H475.947V11.626h10.688v36.9q11.4-5.7,21.945-5.7,14.247,0,19.166,8.1t4.916,28.8v39.6H521.975v-39.3q0-15.6-2.921-21.374t-12.326-5.776a45.4,45.4,0,0,0-17.386,3.451l-2.707,1.049Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.9,15.527h35.767q14.675,0,22.017,6.375t7.339,20.024q0,9.753-3.207,15.226a22.168,22.168,0,0,1-9.476,8.625q15.673,5.7,15.675,24.45,0,15.6-7.838,22.349t-22.657,6.75H552.9Zm35.339,10.2H563.868v35.85h25.365q9.119,0,13.324-4.576t4.2-13.8q0-9.226-4.49-13.35T588.235,25.727Zm1.141,45.9H563.868v37.5h26.22q9.69,0,14.749-4.274T609.9,89.776a20.335,20.335,0,0,0-2.067-9.6,12.282,12.282,0,0,0-5.486-5.55A29.732,29.732,0,0,0,589.376,71.626Z",
    style: {
      fill: "#9a9bab",
      stroke: "#9a9bab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.4,27.376V14.327h10.688V27.376Zm0,91.95v-75h10.688v75Z",
    style: {
      fill: "#9a9bab",
      stroke: "#9a9bab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.088,54.077H681.43V89.926q0,12.9,1.781,16.95t8.478,4.05l12.683-.9.713,9.3a92.824,92.824,0,0,1-14.535,1.651q-11.115,0-15.39-5.7t-4.275-21.75V54.077H660.768v-9.75h10.117V21.376H681.43V44.327h22.658Z",
    style: {
      fill: "#9a9bab",
      stroke: "#9a9bab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.145,52.876q-15.535,0-15.534,11.4,0,5.25,3.563,7.424t16.245,4.5q12.681,2.328,17.955,6.526t5.272,15.75q0,11.551-7.053,16.949T738,120.826a122.841,122.841,0,0,1-20.806-2.1l-4.274-.75.57-9.75q16.244,2.551,24.51,2.549T750.613,108q4.345-2.774,4.346-9.3t-3.7-8.849q-3.707-2.325-16.245-4.426T717.2,79.276q-5.272-4.05-5.272-15t7.339-16.2q7.337-5.248,18.311-5.25a142.819,142.819,0,0,1,21.8,2.1l3.99.75-.285,9.6A176.621,176.621,0,0,0,738.145,52.876Z",
    style: {
      fill: "#9a9bab",
      stroke: "#9a9bab",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.688,30.692a8.787,8.787,0,0,1-6.632-2.766,9.472,9.472,0,0,1-2.642-6.806,9.449,9.449,0,0,1,2.625-6.79,9.3,9.3,0,0,1,13.212.016,9.55,9.55,0,0,1,2.607,6.808,9.522,9.522,0,0,1-2.589,6.79A8.651,8.651,0,0,1,781.688,30.692Zm-.052-17.606a7.217,7.217,0,0,0-5.478,2.346,8,8,0,0,0-2.2,5.688,8,8,0,0,0,2.2,5.687,7.589,7.589,0,0,0,10.955.017,7.957,7.957,0,0,0,2.2-5.688,8.019,8.019,0,0,0-2.2-5.7A7.214,7.214,0,0,0,781.636,13.086Zm-1.8,9.625v3.746H777.8v-10.6h3.849a4.858,4.858,0,0,1,2.993.77,2.733,2.733,0,0,1,1,2.31,5.04,5.04,0,0,1-.4,2.292,2.853,2.853,0,0,1-1.383,1.208l1.925,4.025h-2.135l-1.75-3.746ZM779.8,17.5v3.57h2.064a1.883,1.883,0,0,0,1.366-.42,1.874,1.874,0,0,0,.419-1.365q0-1.787-2.169-1.785Z",
    style: {
      fill: "#9a9bab"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.d0477d56592eafdd95fdd75b3dc5b95b.svg";
export { ForwardRef as ReactComponent };